import { Logger } from "./logger"

declare let $load: (url: string) => Promise<void>

export function isEmpty(data: any) {
  if (data == null) return true
  if (typeof data !== "object") {
    if (typeof data == "boolean") return false
    return typeof data == "number"
      ? data + 0 !== data
        ? true
        : false
      : !data
  }
  if (Array.isArray(data)) {
    return !data?.length
  }
  return !Object.keys(data)?.length

}

export function isNumber(value: any) {
  return typeof value === "number" && value + 0 === value
}

export function isInt(value: any) {
  return isNumber(value) && Number.isInteger(value)
}

// 优化点：添加快速出口，去除Math.abs
export function isLarge(n) {
  if (n === 0) return false
  const abs = n < 0 ? -n : n
  return abs >= 1e15 || abs <= 1e-15
}

export function deepClone<T>(obj: T, map = new WeakMap()): T {
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  if (globalThis.Element && obj instanceof globalThis.Element) {
    return obj
  }

  if (obj instanceof WeakMap || obj instanceof WeakSet) {
    return obj
  }

  if (map.has(obj)) {
    return map.get(obj)
  }

  let clone: any
  if (Array.isArray(obj)) {
    clone = []
  } else if (obj instanceof Map) {
    clone = new Map()
    obj.forEach((value, key) => {
      clone.set(key, deepClone(value, map))
    })
    return clone
  } else if (obj instanceof Set) {
    clone = new Set()
    obj.forEach(value => {
      clone.add(deepClone(value, map))
    })
    return clone
  } else if (obj instanceof Date) {
    return new Date(obj.getTime()) as any
  } else if (obj instanceof RegExp) {
    return new RegExp(obj.source, obj.flags) as any
  } else {
    clone = Object.create(Object.getPrototypeOf(obj))
  }

  map.set(obj, clone)

  for (const key of Reflect.ownKeys(obj)) {
    try {
      (clone as any)[key] = deepClone((obj as any)[key], map)
    } catch (err) {
      (clone as any)[key] = (obj as any)[key]
      Logger.error(`deep clone error which key is ${key.toString()}, source is`, (obj as any)[key])
    }
  }

  return clone
}


/**
 * 获取资源
 * @param pageKey
 * @returns
 */
export function loadBuiltFile(path: string) {
  if (path.startsWith('/')) {
    path = path.substring(1)
  }
  return $load(path)
}

/**
 * 获取浮层资源
 * @param pageCode
 * @returns
 */
export function loadOverlay(pageCode: string) {
  return loadBuiltFile(`/dist/overlays/${pageCode}.mjs`)
}
